import { defineMessages } from 'react-intl';

export default defineMessages({
  getSubscription: {
    id: 'widget.overlay-buttons.get-subscription',
    defaultMessage: 'Subscribe {price}/mo.',
  },
  buyFrom: {
    id: 'widget.overlay-buttons.buy-from',
    defaultMessage: 'Buy from {price}',
  },
  buy: {
    id: 'widget.overlay-buttons.buy',
    defaultMessage: 'Buy {price}',
  },
  rent: {
    id: 'widget.overlay-buttons.rent',
    defaultMessage: 'Rent {price}',
  },
});



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/common/translations/overlay.js